export default __webpack_public_path__ + "static/media/hero_title_one_mobile.0f8bd8b3.svg";